import {GetRemoteUrlError} from './GetRemoteUrlError.js'

export class PageErrorsFactory {
  static getRemoteUrlError = msg => new GetRemoteUrlError(msg)
}
